import { Provider } from '@angular/core';
import { signalStore } from '@ngrx/signals';
import { learnerUsersState, LearnerUserStateService } from './learner-users-state.service';

export const LearnerApplicationStore = signalStore(learnerUsersState());

export function provideLearnerApplicationState(): Provider[] {
	return [LearnerApplicationStore, LearnerUserStateService];
}
